<script>
  import { apiServer } from "../config.js";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import { fade } from "svelte/transition";
  import Load from "../components/Load.svelte";
  import SkContent from "./Rule/SkContent.svelte";
  import KpContent from "./Rule/KpContent.svelte";
  import Modal from "../components/Modal.svelte";

  import AXHR from "../components/js/axhr.js";
  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  $: if (sessions) {
    if (sessions.loggedin == true) {
      window.location.href = "./";
    }
  } else {
    sessions = {
      api: apiServer,
      loggedin: false,
    };
  }

  let alert = [];
  let shake = "shake";
  let require;

  $: require = {
    email: "",
    pass: "",
    pass_verify: "",
    firstname: "",
    lastname: "",
    setuju: "",
  };
  let number;
  $: number = {};

  let email;
  $: email = {
    email: require.email,
  };

  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        errorForm = [
          ...errorForm,
          { field: e, message: "Pastikan Email sudah tepat" },
        ];
        if (document.getElementById(e + "-warning")) {
          document.getElementById(e + "-warning").style.display =
            "inline-block";
          document.getElementById(e + "-warning").innerHTML =
            "Pastikan Email sudah tepat";
        }
        if (document.getElementById(e + "-labelwarning")) {
          document.getElementById(e + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  let loading = false;
  let success;
  $: success = false;
  async function handleSubmit(event) {
    loading = true;
    let valid;
    let payload;
    valid = validator();
    payload = {
      title: "Mr",
      email: require.email,
      password: require.pass,
      confirmPassword: require.pass_verify,
      firstName: require.firstname,
      lastName: require.lastname,
      acceptTerms: true,
    };
    if (valid) {
      shake = "";
      AXHR.post(apiServer + "/accounts/register", payload)
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.message,
              color: "green",
            },
          ];
          success = true;
          loading = false;
        })
        .catch(function (error) {
          success = false;
          loading = false;

          shake = "shake";
          alert = [
            ...alert,
            {
              title: "Oops...",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        });
    } else {
      success = false;
      loading = false;
      shake = "shake";
    }
  }
</script>

<svelte:head>
  <title>Register To Mikhub</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<main
  transition:fade
  class="max-w-screen-xl px-2 pt-0 mx-auto mb-2 lg:pt-0 md:pt-16"
>
  {#if loading}
    <Load />
  {/if}
  <div class={shake}>
    <div class="w-full mx-auto mt-24 lg:mt-5 md:w-2/4 lg:w-2/5">
      <div class="flex justify-center font-bold">
        <img
          on:click={() => redirect("/")}
          src="./assets/logo/logo.svg"
          width="274"
          height="64"
          alt="logo"
          class="h-16 cursor-pointer"
        />
      </div>
      <h2 class="mb-4 text-center text-gray-700 text-1xl">
        <b>Register</b> your self now !
      </h2>

      {#if success == true}
        <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
          <div class="w-full mx-auto mb-2">
            <div class="block p-5 py-10 bg-white rounded-lg shadow-md group">
              <p class="text-center">
                <b class="block mb-5 text-xl"
                  >Account registration is successful
                </b>We have sent the code to your email, please check and use it
                to activate your account
                <a
                  href="/aktivasi"
                  class="block px-5 py-2 my-5 text-white bg-gray-600 rounded"
                  >ACTIVATE</a
                >
              </p>
            </div>
          </div>
        </div>
      {:else}
        <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
          <div class="w-full mx-auto mb-2">
            <div class="block px-4 py-3 bg-white rounded-lg shadow-md group">
              <ul class="mt-5 mb-10 list-unstyled multi-steps tablist">
                <li role="presentation" id="stepID1" class="active">
                  <span class="text-sm">Register</span>
                </li>
              </ul>
              <div id="stepcontID1" class="stepcontID">
                <form
                  class="px-2"
                  autocomplete="off"
                  on:submit|preventDefault={handleSubmit}
                >
                  <section class="mt-5">
                    <label
                      for="firstname"
                      class="relative block text-sm font-light"
                    >
                      <input
                        class="w-full rounded-lg form-input"
                        name="firstname"
                        id="firstname"
                        autocomplete="off"
                        type="text"
                        placeholder="First Name"
                        bind:value={require.firstname}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="firstname-labelwarning"
                        >First Name
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="firstname-warning"
                      />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label
                      for="lastname"
                      class="relative block text-sm font-light"
                    >
                      <input
                        class="w-full rounded-lg form-input"
                        name="lastname"
                        id="lastname"
                        autocomplete="off"
                        type="text"
                        placeholder="Last Name"
                        bind:value={require.lastname}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="lastname-labelwarning"
                        >Last Name
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="lastname-warning"
                      />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label
                      for="email"
                      class="relative block text-sm font-light"
                    >
                      <input
                        class="w-full rounded-lg form-input"
                        name="email"
                        id="email"
                        autocomplete="off"
                        type="text"
                        placeholder="Email"
                        bind:value={require.email}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="email-labelwarning"
                        >Email
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="email-warning"
                      />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label for="pass" class="relative block text-sm font-light">
                      <input
                        class="w-full rounded-lg form-input"
                        name="pass"
                        id="pass"
                        autocomplete="off"
                        type="password"
                        placeholder="Password"
                        bind:value={require.pass}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="pass-labelwarning"
                        >Password
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="pass-warning"
                      />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label
                      for="pass_verify"
                      class="relative block text-sm font-light"
                    >
                      <input
                        class="w-full rounded-lg form-input"
                        name="pass_verify"
                        id="pass_verify"
                        autocomplete="off"
                        type="password"
                        placeholder="Repeat Password"
                        bind:value={require.pass_verify}
                      />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="pass_verify-labelwarning"
                        >Repeat Password
                      </span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="pass_verify-warning"
                      />
                    </label>
                  </section>
                  <section class="mt-5">
                    <p class="flex text-xs text-gray-500">
                      <label
                        for="setuju"
                        class="relative flex text-sm font-light"
                      >
                        <input
                          name="setuju"
                          id="setuju"
                          type="checkbox"
                          class="my-1 mr-5 text-3xl rounded-lg form-checkbox hover:shadow-outline"
                          bind:checked={require.setuju}
                        />
                        <div>
                          I have read and read
                          <Modal backdropClose size="lg:w-2/5 w-full">
                            <span slot="trigger" let:open>
                              <span on:click={open} class="text-gray-500"
                                >Terms and conditions
                              </span>
                            </span>
                            <div slot="header" class="text-center">
                              <h1 class="text-lg">Terms and conditions</h1>
                            </div>
                            <div
                              slot="content"
                              class="h-auto"
                              style="max-height:100%"
                            >
                              <SkContent />
                            </div>
                          </Modal>

                          and
                          <Modal backdropClose size="lg:w-2/5 w-full">
                            <span slot="trigger" let:open>
                              <span on:click={open} class="text-gray-500"
                                >Privacy Policy
                              </span>
                            </span>
                            <div slot="header" class="text-center">
                              <h1 class="text-lg">Privacy Policy</h1>
                            </div>
                            <div
                              slot="content"
                              class="h-auto"
                              style="max-height:100%"
                            >
                              <KpContent />
                            </div>
                          </Modal>
                          Mikhub
                        </div>
                        <span
                          class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                          id="setuju-warning"
                        />
                      </label>
                    </p>
                  </section>

                  <div class="flex items-center justify-between my-5">
                    <button
                      type="button"
                      class="w-auto px-5 py-2 font-light text-gray-500 text-1xl focus:outline-none"
                      on:click={() => window.history.go(-1)}
                    >
                      Back ...
                    </button>

                    {#if loading}
                      <button
                        type="submit"
                        class="w-auto px-5 py-2 text-gray-100 bg-gray-700 rounded-lg opacity-25 text-1xl active:bg-gray-500 focus:outline-none"
                        disabled="disabled"
                      >
                        PROCESS...
                      </button>
                    {:else}
                      <button
                        type="submit"
                        class="w-auto px-5 py-2 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                        on:click={handleSubmit}
                      >
                        REGISTER NOW
                      </button>
                    {/if}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</main>
<div class="flex justify-center max-w-screen-xl px-5 py-1 mx-auto items-bottom">
  <div
    class="w-full mt-4 text-sm font-light text-center text-gray-700 sm:py-2 sm:mt-0"
  >
    <div>
      <span class="ml-1 text-gray-700">© 2021 Mikhub — RakIT Labs</span>
    </div>
  </div>
</div>
